'use client';

import { Slot } from '@magicschool/spellbook/components/Slot';
import { cn } from '@magicschool/spellbook/lib/utils';
import type { ComponentProps } from 'react';
import type { CarouselApi } from './Carousel';

export type CarouselItemSlotProps = ComponentProps<'div'> & {
  index: number;
  api: CarouselApi;
};

export const CarouselItemSlot = Slot<CarouselItemSlotProps>({
  displayName: 'Carousel.Item',
  preventOverride: true,
  renderDefault: ({ index, api, className, ...props }) => {
    return (
      <div
        data-spellbook-name="carousel-item"
        role="group"
        aria-roledescription="slide"
        aria-hidden={index !== (api?.selectedScrollSnap() ?? 0)}
        className={cn('min-w-0', 'min-h-0', 'shrink-0', 'grow-0', 'basis-full', 'ps-4', className)}
        {...props}
      />
    );
  },
});
